<template>
  <div>
    <v-container>
      <v-row justify="center">
       <apexchart style="margin-right:2em;" width="420" type="donut" :options="chartOptions" :series="series"></apexchart>
      </v-row>
    </v-container>
        
    </div>
</template>

<script>
export default {
  name:'demo-pie', 
  props: {
    parentDemo: Object,
    parentDomain: String,
  },

  created() {
    this.deconstruct(this.parentDemo)
  },

  data() {
    return {
      series: [],
      chartOptions: {
        labels: [],
        //colors: ['#20246f', '#6c2d6a', '#B83e5D', '#DC722F', '#EE8C18', '#FFA600', '#FFd032'],
        colors: ['#274b69', '#3f4d63', '#85a1c1', '#C1A585', '#BDBDBD'],
        chart: {
          type: 'donut',
        },
        dataLabels: {
            enabled: false
            },
            tooltip: {
          enabled: true,
          theme: 'dark',
          y: {
            formatter: function formatter(val) {
              return (val).toFixed(1) + '%'},
          }
        },
        legend: {
          show: true,
          offsetY: 0,
          position: 'right',
        },
        plotOptions: {
          pie: {
            expandOnClick: false
          }
        },
        states: {
          active: {
            filter: {
              type: 'none' /* none, lighten, darken */
            }
          }
        },
        responsive: [{
          breakpoint: '960',
          options: {
            chart: {
              width: 340
            },
            legend: {
              show: true,
              offsetY: 0,
              position: 'bottom',
            }
          }
        }]
      },
    }
  },

  methods: {

    deconstruct(data) {
      let d = data.demo.domains[this.parentDomain].data
        let percent = []
        let cat = []
        for (const i in d) {
            if (i[0] == 3) {
              percent.push(d[i].percent)
              cat.push(d[i].name)
          }
        }
        this.chartOptions = {...this.chartOptions, ...{
          labels: cat
        }}
        this.series = percent
    },
  },
}
</script>
